import { UserRole } from "@/core/services/api/enums/UserRole";
import store from "@/store";
import { RouteLocationRaw } from "vue-router";
import { GuardedElement } from "@/core/config/MainMenuConfig";
import { CurrencyType } from "@/core/services/api/interfaces/manager/CurrencyUnit";

export interface HeaderMenuElement extends GuardedElement<HeaderMenuElement> {
  heading: () => string;
  route: RouteLocationRaw;
  subTitle?: string;
  svgIcon?: string;
  fontIcon?: string;
  svgClass?: string;
}

export const HeaderMenuElements: HeaderMenuElement[] = [
  {
    heading: (): string => "Verification",
    route: { name: "profile.verifications" },
    svgIcon: "/media/icons/duotune/general/gen049.svg",
    svgClass: "svg-icon-danger",
    fontIcon: "bi-app-indicator",
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean => store.getters.isUserComplianceTrackingRequired,
  },
  {
    heading: (): string => "Accounts",
    route: "/manager/accounts",
    svgIcon: "/media/icons/duotune/finance/fin008.svg",
    fontIcon: "bi-app-indicator",
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean => store.getters.isIndividualOrHas2FA,
    sub: () => [
      {
        heading: (): string => "Fiat",
        route: {
          name: "manager.accounts.list",
          params: { currency_type: CurrencyType.FIAT },
        },
        svgIcon: "/media/icons/duotune/finance/fin008.svg",
        fontIcon: "bi-app-indicator",
        roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
        isAllowed: (): boolean => store.getters.isIndividualOrHas2FA,
      },
      {
        heading: (): string => "Crypto",
        route: {
          name: "manager.accounts.list",
          params: { currency_type: "crypto" },
        },
        svgIcon: "/media/icons/duotune/finance/fin008.svg",
        fontIcon: "bi-app-indicator",
        roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
        isAllowed: (): boolean =>
          store.getters.isIndividualOrHas2FA &&
          store.getters.isCompanyCryptoEnabled,
      },
    ],
  },
  {
    heading: (): string => "Sub accounts",
    route: "/affiliates",
    svgIcon: "/media/icons/duotune/finance/fin003.svg",
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean =>
      store.getters.isIndividualOrHas2FA &&
      store.getters.isCompanyFeatureAffiliationEnabled,
    sub: () => [
      {
        heading: (): string => "KYC",
        route: {
          name: "manager.affiliates.compliance-trackings",
        },
        roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
        isAllowed: (): boolean => store.getters.isIndividualOrHas2FA,
      },
      {
        heading: (): string => "Transactions",
        route: "/affiliates/transactions",
        svgIcon: "/media/icons/duotune/finance/fin003.svg",
        roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
        isAllowed: (): boolean => store.getters.isIndividualOrHas2FA,
        sub: () => [
          {
            heading: (): string => "Completed Transactions",
            route: {
              name: "manager.affiliates.transactions",
              params: { mode: "approved_transactions" },
            },
            roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
            isAllowed: (): boolean => store.getters.isIndividualOrHas2FA,
          },
          {
            heading: (): string => "Pending Transactions",
            route: {
              name: "manager.affiliates.transactions",
              params: { mode: "pending_transactions" },
            },
            roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
            isAllowed: (): boolean => store.getters.isIndividualOrHas2FA,
          },
        ],
      },
    ],
  },
  {
    heading: (): string => "KYC",
    route: "/manager/compliance-trackings",
    svgIcon: "/media/icons/duotune/files/fil010.svg",
    fontIcon: "bi-app-indicator",
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean => store.getters.isIndividualOrHas2FA,
  },
  {
    heading: (): string => "Reports",
    subTitle: "Reports statistic",
    route: "/manager/reports",
    svgIcon: "/media/icons/duotune/files/fil017.svg",
    svgClass: "svg-icon-info",
    fontIcon: "bi-app-indicator",
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean => store.getters.userHasTwoFactorAuth,
  },
  {
    heading: (): string => "Imports",
    subTitle: "Imports statistic",
    route: "/manager/imports",
    svgIcon: "/media/icons/duotune/files/fil018.svg",
    svgClass: "svg-icon-success",
    fontIcon: "bi-app-indicator",
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean => store.getters.userHasTwoFactorAuth,
  },
  {
    heading: (): string => "Notifications",
    route: "/manager/notifications",
    svgIcon: "/media/icons/duotune/general/gen022.svg",
    fontIcon: "bi-app-indicator",
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean => store.getters.isIndividualOrHas2FA,
  },
];
